module.exports = __webpack_public_path__ + "co.svg?ca05f9f988e26ed6e1f3a300bae318fe";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/co.svg
// module id = 782
// module chunks = 27